import { c as conversions$1 } from "./conversions.js";
const conversions = conversions$1;
function buildGraph() {
  const graph = {}, models = Object.keys(conversions);
  for (let len = models.length, i = 0; i < len; i++)
    graph[models[i]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return graph;
}
function deriveBFS(fromModel) {
  const graph = buildGraph(), queue = [fromModel];
  for (graph[fromModel].distance = 0; queue.length; ) {
    const current = queue.pop(), adjacents = Object.keys(conversions[current]);
    for (let len = adjacents.length, i = 0; i < len; i++) {
      const adjacent = adjacents[i], node = graph[adjacent];
      node.distance === -1 && (node.distance = graph[current].distance + 1, node.parent = current, queue.unshift(adjacent));
    }
  }
  return graph;
}
function link(from, to) {
  return function(args) {
    return to(from(args));
  };
}
function wrapConversion(toModel, graph) {
  const path = [graph[toModel].parent, toModel];
  let fn = conversions[graph[toModel].parent][toModel], cur = graph[toModel].parent;
  for (; graph[cur].parent; )
    path.unshift(graph[cur].parent), fn = link(conversions[graph[cur].parent][cur], fn), cur = graph[cur].parent;
  return fn.conversion = path, fn;
}
var route = function(fromModel) {
  const graph = deriveBFS(fromModel), conversion = {}, models = Object.keys(graph);
  for (let len = models.length, i = 0; i < len; i++) {
    const toModel = models[i];
    graph[toModel].parent !== null && (conversion[toModel] = wrapConversion(toModel, graph));
  }
  return conversion;
};
export {
  route as r
};
//# sourceMappingURL=route.js.map
